// ignore-string-externalization

import React from 'react';
import { loadBlog } from '../../utils/redux/store/blog';
import { Blog } from '../../features/Blog';

const BlogPage = () => {
  return <Blog />;
};

BlogPage.getInitialProps = async ({
  store,
  smartlingLanguage,
  preview,
}: $TSFixMe) => {
  return store
    .dispatch(
      loadBlog({ category: 'all', smartlingLanguage, preview } as $TSFixMe),
    )
    .then(() => {
      return { loaded: true, preview };
    });
};

export default BlogPage;
